class AddressBook {
    constructor ( {addresses} ) {
        this.addresses = Array.isArray( addresses ) ? addresses : [];
    }

    getAddressesByType ( type ) {
        return this.addresses.filter( addr => addr.addressType === type );
    }

    getPrimaryAddressesByType ( type ) {
        return this.addresses.find( addr => addr.addressType === type && addr.primary );
    }

    getById ( id ) {
        return this.addresses.find( addr => addr.id === id );
    }

    getSuggestedBillingAddress ( cart ) {
        const billToId = cart?.payment?.billingAddress?.id;
        if ( billToId ) {
            return this.getById( billToId );
        }

        return this.getPrimaryAddressesByType( 'Billing' );
    }

    getSuggestedShippingAddress ( cart ) {
        const shipToId = cart?.shippingAddress?.id;
        if ( shipToId ) {
            return this.getById( shipToId );
        }

        return this.getPrimaryAddressesByType( 'Shipping' );
    }
}

export default AddressBook;
